import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../../../shared/pipes/shared-pipes.module';
import { VehicleGenericForm } from './vehicle-generic-form.component';
import { VehicleGenericResults } from './vehicle-generic-results.component';

@NgModule({
    declarations: [
        VehicleGenericForm,
        VehicleGenericResults
    ],
    providers: [
    ],
    exports: [
        VehicleGenericForm,
        VehicleGenericResults
    ],
    imports: [
        TableModule,
        SharedModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        SharedPipesModule
    ]
})
export class VehicleGenericBaseModule {
}
